// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__6W2Sx","logo":"Logo_logo__wIBX3"};